import StudentApi from './StudentApi';
export default StudentApi;
